import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';

import Header from './common/Header';
import LearningTab from './LearningTab';
import DiagnosisTab from './DiagnosisTab';
import { useAlert, useLearningHistory } from '../../../../../hooks';

function LearningNoteGM() {
  const location = useLocation();
  const { learningHistoryInfo } = useLearningHistory();
  const [Alert] = useAlert();

  useEffect(() => {
    sessionStorage.setItem('lastPath', location.pathname);
  }, [])
  /**
   * learning: 학습 탭
   * diagnosis: 진단 탭
   */
  const [tabValue, setTabValue] = useState('learning');
  const handleTab = (value) => {
    if (value === 'diagnosis') {
      if (learningHistoryInfo.isCompleteAIDiagnosis !== 'Y') {
        Alert('진단이력이 존재하지 않습니다.');
        return;
      }
    }
    setTabValue(value);
  }

  return (
    <React.Fragment>
      <div className={
        clsx(
          "layout-def tab-wrap",
          tabValue === 'learning' ? "w100p with_bottom_area bg_gray" : 'layout-lr-dark'
        )
      }>
        <Header
          tabValue={tabValue}
          handleTab={handleTab}
        />
        <div className="container study_note gm">
          <div className="inner">
            <div
              className={clsx(
                "tabCont active",
                tabValue === 'learning' ? "study_note_tab1" : ''
              )}
              id="tabCont1"
            >
              <div className="lev_boxes-wrap w736">
                { tabValue === 'learning' && <LearningTab />}
              </div>
              { tabValue === 'diagnosis' && <DiagnosisTab />}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default LearningNoteGM;
